/**
 * This enum is used for referring Primary Navigation URL Path.
 */
export enum MainNavigationEnum {
  LOGIN = 'login',
  NO_ACCESS = 'no-access',
  UNAUTHORIZED = 'unauthorized',
  BULK_ROLE_ASSIGNMENT = 'bulk-role-assignment',
  USERS = 'users',
  TOKENS = 'tokens',
  CLIENTS = 'clients',
  HISTORICAL_PULL = 'historical-pull',
}
